import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'
import appInfo from '@/assets/js/appInfo'

/**
 * 单个商品的信息
 * @typedef GoodsItem
 * @property {number} id 商品唯一id
 * @property {string} name 商品名称
 * @property {number} savePerMonth 每月节省的金额
 * @property {number} price 价格
 * @property {number} applePrice 苹果上的价格?
 */

/**
 * 商品信息
 * @typedef GoodsInfo
 * @property {string} title 标题
 * @property {goodsId} goodsId 商品id
 * @property {Array<>} sets 商品列表
 */

/**
 * 获取商品信息
 * @param goodsId 商品id
 * @param {number} pid 权限Id
 * @return {Promise<GoodsInfo>}
 */
export async function getGoods(goodsId, setId, pid) {
  return axios
    .get(`${Urls.DOMAIN_YKT}/Shop/Data/Goods`, {
      params: {
        goodsId,
        setId,
        pid
      }
    })
    .then(data => {
      let detail = null
      if (data.result.code === 0) {
        detail = data.detail
      }
      return detail
    })
}

/**
 * @typedef OrderInfo 订单信息
 * @property {string} [transactionCode] 账单流水号，支付成功后由支付系统生成
 * @property {string} orderId 订单号
 * @property {string} [productName] 商品名称
 * @property {Date} createTime 订单创建时间
 * @property {number} orderStatus 订单状态
 * @property {number} userId 用户Id
 * @property {number} amount 订单金额
 */

/**
 * 创建订单
 * @param {number} productId 商品id
 * @param {string} source 订单来源
 * @param {number} quantity 购买数量，默认1
 * @return {Promise<{result: ResponseResult, detail: OrderInfo}>}
 */
export async function createOrder(productId, source, quantity = 1) {
  return axios
    .get(`${Urls.DOMAIN_YKT}/Order/Order/CreateOrder`, {
      params: {
        productId,
        source,
        quantity
      }
    })
    .then(data => {
      return data
    })
}

/**
 * 创建支付订单
 * @param {number} payMethod 支付方式
 * @param {number} orderId 订单号
 * @return {Promise<{result:ResponseResult,detail:Object}>}
 */
export async function createPayOrder(
  payMethod,
  orderId,
  extendToken,
  tradeType = 2,
  appId = 31
) {
  // if (appId === '') {
  //   appId = localStorage.getItem('currentAppId')
  // }
  return axios.get(`${Urls.DOMAIN_YKT}/Order/Order/PayOrder`, {
    params: {
      payMethod,
      orderId,
      extendToken,
      tradeType,
      appId
    }
  })
}

/**
 * 支付状态
 * @type {{paymentSuccess: number, paying: number, paymentFailed: number, unPaid: number}}
 */
export const PaymentStatus = {
  /**
   * 未支付
   */
  unPaid: 1,
  /**
   * 支付中
   */
  paying: 2,
  /**
   * 支付成功
   */
  paymentSuccess: 3,
  /**
   * 支付失败
   */
  paymentFailed: 4
}

/**
 * 查询订单支付状态
 * @param {string} orderId 订单id
 * @return {Promise<number>} 支付状态
 */
export async function queryOrderStatus(orderId) {
  return axios
    .get(`${Urls.DOMAIN_YKT}/Order/Order/QueryOrderStatus`, {
      params: {
        orderId
      }
    })
    .then(data => {
      let paymentStatus = PaymentStatus.paymentFailed
      if (data.result.code === 0) {
        paymentStatus = data.detail
      }

      return paymentStatus
    })
    .catch(() => {
      return PaymentStatus.paymentFailed
    })
}

/**
 * 获取优惠券
 * data {userId,type,statusList}
 * @param {number} userId 用户id
 * @param {number} type 用户id  1.平台通用券 2. 指定商品通用券 3.指定商品优惠券
 * @param {number} statusList []返回指定状态的优惠券 0. 生效 1.已使用 2.已锁定 3.已过期
 */
export function getCouponApi(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Coupon/Api/Page`,
    method: 'post',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取有效优惠券数量
 */
export function getCouponCountApi() {
  const url = `${Urls.DOMAIN_YKT}/coupon/api/Count`
  return axios
    .post(url)
    .then(result => {
      return result
    })
    .catch(() => null)
}
